import React from 'react'
import IrregularInteraction from '../../IrregularInteraction'
import ItemImage from '../../ItemImage'
import image from '../../../assets/images/bedroom/item--desk@3x.png'

const points =
  '170.88 34.97 170.91 34.96 109.86 0 0 63.53 0 67.75 0.89 68.28 0.89 70.43 2.66 71.48 2.66 118.73 6.76 121.39 11.3 118.73 11.3 76.6 58.39 104.49 58.39 141.22 62.49 143.88 67.03 141.22 67.03 101.3 157.55 49.1 157.55 92.47 161.65 95.13 166.2 92.47 166.2 44.11 169.19 42.39 169.19 40.26 170.88 39.28 170.88 34.97'

const Desk = props => (
  <IrregularInteraction
    points={points}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 170.91 143.88"
    {...props}
  >
    <ItemImage src={image} />
  </IrregularInteraction>
)

Desk.propTypes = IrregularInteraction.propTypes

export default Desk



// WEBPACK FOOTER //
// ./src/components/items/bedroom/Desk.js